// import Landing from "@/app/landing/router/router-const"
import Admin from "@/app/admin/router/router-const"
import Auth from "@/app/auth/core/router-const"
import Exercise from "@/app/exercise/router/router-const"

export default Object.freeze({
  // ...Landing,
  ...Admin,
  ...Exercise,
  ...Auth,
  CRM: 'crm-layout',
  NOT_FOUND: 'not_found',
  SERVER_ERROR: 'server_error'
})